import { Component, OnInit, Input, QueryList, ViewChildren, ViewChild, ElementRef, Renderer2, Output, EventEmitter } from '@angular/core';
import { MenuItem } from 'src/app/beans/menu/menu-item/menu-item.bean';
import { Router } from '@angular/router';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { MatExpansionPanel } from '@angular/material/expansion';
import { AuthLevel } from 'src/app/enums/auth/auth.enum'
import { isSessionCode } from 'src/app/enums/session/session-code.enum';
import { User } from 'src/app/beans/login/user/user.bean';
@Component({
  selector: 'menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit {

  selected: boolean = false
  private childItems: QueryList<MenuItemComponent>
  @ViewChildren(MenuItemComponent) set _childItems(childItems: QueryList<MenuItemComponent>){
    this.childItems = childItems
  }

  @Input() item             : MenuItem;
  @Input() level            : number  = 0;

  @ViewChild('itemContainer') itemContainer : ElementRef
  @ViewChild('expander'     ) expander      : MatExpansionPanel

  @Output() clickOnItem : EventEmitter<MenuItem>  = new EventEmitter<MenuItem>()
  @Output() openPanel   : EventEmitter<void>      = new EventEmitter<void>    ()

  private BASE_OFFSET_ICON: number = 24;
  private BASE_OFFSET     : number = 30;

  constructor(
    private _router   : Router        ,
    private _session  : SessionManager,
    private _renderer2: Renderer2
  ) { }

  ngOnInit(): void 
  {
    
  }

  hasChildren (): boolean
  {
    return      this.item  
            &&  this.item.children
            &&  this.item.children.length > 0
  }

  hasIcon (): boolean {
    return      this.item  
            &&  this.item.icon != undefined
  }

  getOffset ( ) {
    if(this.level)  
      if ( this.hasIcon() ) return `${this.BASE_OFFSET_ICON * this.level}px`
      else                  return `${this.BASE_OFFSET      * this.level}px`
    else            return "0px";
  }

  getOffsetValue ( ) {
    if(this.level)  
      if ( this.hasIcon() ) return this.BASE_OFFSET_ICON * this.level
      else                  return this.BASE_OFFSET      * this.level
    else            return 0;
  }

  checkIfHasItem ( id: string ): MenuItemComponent
  {    

    if (this.item.id == id){      
      return this
    }
    if (this.childItems)
    {
      const item = this.childItems.find (el => el.checkIfHasItem(id) != undefined )
      
      if (item)  return item 
    }
    return undefined
  }

  setActiveItem(){
    this.selected = true
  }

  clickItem(item: MenuItem){
    if (item.children) return
    this.clickOnItem.emit(item)
  }

  selectItem(){
    this.openPanel.emit()
    this._renderer2.addClass(this.itemContainer.nativeElement   , 'selectedItem' )
  }

  unselectItem()
  {
    this._renderer2.removeClass(this.itemContainer.nativeElement, 'selectedItem' )
  }

  expand(){
    this.expander.open()
  }

  canAccess( auths: AuthLevel[] )
  {
    if( !auths ) return true

    const resp = this._session.user().get()
    if ( isSessionCode(resp) ) return false
    
    const user: User = resp as User

    return auths.find ( auth => user.level == auth ) ? true : false
  }
}
